import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ProgramCard from '../components/Program/ProgramCard';
import { ProgramCardWrapper } from '../styledComponents/theme';
import {FrameContainer} from '../styledComponents/layout'
import { Helmet } from 'react-helmet';

const ProgramsPage = (props) => {
  const programs = props.data.allProgram.edges.map(edge => {return edge.node});
  const {meta} = props;
  return (
    <FrameContainer>
      <Helmet title={meta.title + "/番組一覧"} meta={[
        {name: 'description', content: meta.description},
      ]}/>
      <h1>番組一覧</h1>
      <ProgramCardWrapper>
        {programs.map(program => <ProgramCard {...program} key={program.id} />)}
      </ProgramCardWrapper>
    </FrameContainer>
  );
}

export const query = graphql`
query programsQuery {
  allProgram(filter: {isPublished: {eq: true}}, sort: {fields: [orderNumber], order: ASC}) {
    edges {
      node {
        id
        programId
        title
        orderNumber
        posterUrl
        summary
        thumbnailUrl
        title
        isPublished
      }
    }
  }
}
`;

export default ProgramsPage;



// WEBPACK FOOTER //
// ./src/pages/programs.js